import {observer} from "mobx-react";
import {Component} from "preact";
import {occupancyModel, OccupancyResponse} from "../model";
import {resources} from "../resources";
import {Button} from "./controls/Button";
import style from "./OccupancyListView.module.css";

type OccupancySelectHandler = (occupancy: OccupancyResponse) => void;

export const OccupancyListView = observer(
	class OccupancyListView
		extends Component<{ onSelectOccupancy: OccupancySelectHandler; onAddLocation: () => void }>
	{
		render() {
			const {onSelectOccupancy, onAddLocation} = this.props;
			return (
				<div class={style.occupancyListView}>
					<div class={style.title}>
						{resources.strings.MyLockers}
					</div>

					{occupancyModel.occupancies.map(occupancy => (
						<OccupancyButton occupancy={occupancy} onClick={onSelectOccupancy} key={occupancy.id} />
					))}

					<Button onClick={onAddLocation}>
						{resources.strings.AddLocation}
					</Button>
				</div>
			);
		}
	},
);

const OccupancyButton = observer(
	class OccupancyButton extends Component<{ occupancy: OccupancyResponse; onClick: OccupancySelectHandler }> {
		render() {
			const {occupancy} = this.props;
			return (
				<Button choice onClick={this.handleClick}>
					<div class={style.occupancyButtonContent}>
						<div class={style.location}>
							<div class={style.siteName}>{occupancy.box.cube.site.name}</div>
							<div class={style.cubeName}>{occupancy.box.cube.name}</div>
						</div>
						<div class={style.lockerNumber}>
							{occupancy.box.name}
						</div>
					</div>
				</Button>
			);
		}

		private handleClick = () => this.props.onClick(this.props.occupancy);
	},
);
